module.exports = __webpack_public_path__ + "static/img/3f.3bb86b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3f.jpg
// module id = 3tv+
// module chunks = 0